import keyMirror from 'keymirror';

const RADIO_SIZES = keyMirror({
  sm: null,
  lg: null,
});

export default RADIO_SIZES;
